import _ from 'underscore';
import { Iterable } from 'immutable';

export default {
  getInitialState() {
    return this.getState();
  },

  getState() {
    return this._state;
  },

  getInState(path) {
    const state = this.getState();

    if (Iterable.isIterable(state)) {
      return state.getIn(_pathize(path));
    }

    return state[path];
  },

  setState(state) {
    if (!state && this.title === 'CuesheetStore') {
      console.error(new Error('setting falsy state')); // this will give us a stack trace to see where the invalid stae is getting set
    }
    this._state = state;
    return this._state;
  },

  setStateAndTrigger(state) {
    this._trigger(this.setState(state));
  },

  setInState(key, val) {
    const state = this.getState();

    if (Iterable.isIterable(state)) {
      return this.setState(state.setIn(_pathize(key), val));
    }

    state[key] = val;
    return this.setState(state);
  },

  setInStateAndTrigger(key, val) {
    const state = this.getState();

    if (Iterable.isIterable(state)) {
      this.setStateAndTrigger(state.setIn(_pathize(key), val));
    } else {
      state[key] = val;
      this.setStateAndTrigger(state);
    }
  },

  deleteInState(key) {
    const state = this.getState();

    if (Iterable.isIterable(state)) {
      return this.setState(state.deleteIn(_pathize(key)));
    }

    delete state[key];
    return this.setState(state);
  },

  deleteInStateAndTrigger(key) {
    const state = this.getState();

    if (Iterable.isIterable(state)) {
      return this.setStateAndTrigger(state.deleteIn(_pathize(key)));
    }

    delete state[key];
    return this.setStateAndTrigger(state);
  },

  mergeState(obj) {
    const state = this.getState();

    if (Iterable.isIterable(state)) {
      return this.setState(state.merge(obj));
    }

    return this.setState(_.extend(state, obj));
  },

  mergeStateAndTrigger(obj) {
    const state = this.getState();

    if (Iterable.isIterable(state)) {
      this.setStateAndTrigger(state.merge(obj));
    } else {
      this.setStateAndTrigger(_.extend(state, obj));
    }
  },

  _trigger() {
    this.trigger(this.getState());
  },

  forceUpdate() {
    this._trigger();
  },
};

function _pathize(path) {
  if (!Array.isArray(path)) path = [path];
  return path;
}
